<div class="form-field__label-row">
  <label
    class="form-field__label"
    [attr.id]="labelId()"
    [attr.for]="labelForId()"
    (click)="onLabelClick($event)"
  >
    <span class="form-field__label-text">{{ label() }}</span>
    @if (required()) {
      <span class="form-field__required-mark" aria-hidden="true">*</span>
    }
  </label>
</div>

<div class="form-field__control">
  <ng-content />
</div>

@if (hint(); as hintText) {
  <p class="form-field__hint" [id]="hintId()">{{ hintText }}</p>
}

@if (error(); as errorText) {
  <p class="form-field__error" [id]="errorId()" aria-live="polite">{{ errorText }}</p>
}
